module.exports = __webpack_public_path__ + "static/media/logo.6c6ec8ec.jpg";